import { OverlayType } from '../../constants/common'
import { ICConfig } from './ic'

export class ICFConfig extends ICConfig {
  static type = OverlayType.Icf
  static abbreviation = 'icf'
  static label = 'Ichimoku Cloud (Full)'
  static shortLabel = 'Ichimoku Full'
}
